"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ClientNameAndUid = function (_a) {
    var name = _a.name, uid = _a.uid;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "text-2xl font-bold leading-tight" }, name || '–'),
        uid && react_1.default.createElement("div", { className: "text-gray" }, uid)));
};
exports.default = ClientNameAndUid;
//# sourceMappingURL=ClientNameAndUid.js.map